module.exports = __webpack_public_path__ + "static/img/machu.9f95f16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/machu.jpg
// module id = RvPL
// module chunks = 1